// extracted by mini-css-extract-plugin
export default {"pill":"index__pill--54asV","conditions-container":"index__conditions-container--A7zwG"};